import { ISearchFilterStoreSegment } from './SearchFilter.interface';

export const searchFilterStoreSelector = (state: ISearchFilterStoreSegment) => state.searchFilter;
